<template>
  <div>
    <label for="" class="title_style">{{ title }}</label>
    <p>{{ subTitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: [String, Number]
    },
    subTitle: {
      type: [String, Number]
    }
  }
};
</script>

<style>
.title_style {
  color: #747474;
  font-size: 12px;
}
.sub_style {
  color: #282c52;
  font-size: 14px;
}
</style>
